export default "__VITE_ASSET__BKkEnVqV__"